<template lang="pug">
div(v-bind='wrapperType')
  slot(:results='content')
    template(v-if='content.length === 0')
      slot(name='empty')

    template(v-else)
      slot(name='results' :results='content')
        template(v-for='(result, index) in content' :key='result.id')
          ConstructorioRefinedContent(v-if='isRefinedContent(result)' :content='result.result')
          div(
            v-else
            :data-cnstrc-item-id='result.result.data?.id'
            :data-cnstrc-item-name='result.result.value'
            :data-cnstrc-item-variation-id='result.result.data?.variation_id'
          )
            slot(name='result' :result='result.result' :index='index')
</template>

<script setup lang="ts">
import type { BrowseResultData } from '@constructor-io/constructorio-client-javascript'
const { $device } = useNuxtApp()

const { instance } = useConstructorInject()

interface ContentResult {
  result: RefinedContent['data']
  type: 'CONTENT'
  id: string
}
interface ProductResult {
  result: Partial<BrowseResultData>
  type: 'PRODUCT'
  id: string
}

type Result = ContentResult | ProductResult

const isRefinedContent = (result: Result): result is ContentResult => {
  return result.type === 'CONTENT'
}

const content = computed(() => {
  const results: Result[] = instance.state.value.results.map((result) => ({
    result,
    type: 'PRODUCT',
    id: result.data?.id || '', // Constructor type says optional but we know it's always there
  }))
  const count = results.length
  if (count === 0) return results

  // Note: Currently we only support 1x IMAGE_TILE ads.
  instance.state.value.refinedContent.forEach((item) => {
    const content: ContentResult = { result: item.data, type: 'CONTENT', id: item.id }
    // Example image url:
    // https://a.storyblok.com/f/148322/648x486/5e6fa3f16e/realtruck-builder-browse.png

    // Place the ad in the correct position (Not zero based)
    let position = item.data.position - 1

    // If the position is outside of the bounds of the result, then they are just shown at the end.
    if (count <= position) {
      results.push(content)
      return
    }
    // On Mobile it needs to be an even number as it will stretch full width
    if ($device.value.isMobile) {
      position = position % 2 === 0 ? position : position + 1
    }

    results.splice(position, 0, content)
  })
  return results
})

const wrapperType = computed(() => {
  const attributes: Record<string, string> = {
    'data-cnstrc-num-results': instance.state.value.resultTotal.toString(),
  }

  if (instance.state.value.searchType === 'browse') {
    attributes['data-cnstrc-browse'] = ''
    attributes['data-cnstrc-filter-name'] = instance.state.value.browseFacet
    attributes['data-cnstrc-filter-value'] = instance.state.value.browseFacetValue
  } else if (instance.state.value.searchType === 'search') {
    attributes['data-cnstrc-search'] = ''
  }

  return attributes
})
</script>
